module.exports = __webpack_public_path__ + "static/media/One-Stop Service Provider.53bab6ae.webp";